import {
  SET_COURSES_STATUS,
  SET_COURSES_TYPE,
  SET_COURSES_CATEGORY,
  SET_COURSES_TEACHER,
  SET_COURSES_HOT,
  SET_COURSES_LEVEL,
  SET_COURSES_FACULT
} from '@/store/mutation-types'

export default {
  [SET_COURSES_STATUS] (state, payload) {
    state.searchCoursesStatus = payload
  },
  [SET_COURSES_TYPE] (state, payload) {
    state.searchCoursesType = payload
  },
  [SET_COURSES_CATEGORY] (state, payload) {
    state.searchCoursesCategory = payload
  },
  [SET_COURSES_TEACHER] (state, payload) {
    state.searchCoursesTeacher = payload
  },
  [SET_COURSES_HOT] (state, payload) {
    state.searchCoursesHot = payload
  },
  [SET_COURSES_LEVEL] (state, payload) {
    state.searchCoursesLevel = payload
  },
  [SET_COURSES_FACULT] (state, payload) {
    state.searchCoursesFacult = payload
  }
}



// WEBPACK FOOTER //
// ./src/components/courses/store/mutations.js